"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4448],{

/***/ 81649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DZ": function() { return /* binding */ AvatarSize; },
/* harmony export */   "rH": function() { return /* binding */ AVATAR_SIZE_METRICS; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11717);
/* harmony import */ var _components_common_EFinderImage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11247);
/* harmony import */ var _components_common_SvgIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34368);
/* harmony import */ var _public_icons_profile_32_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42079);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39854);
/* harmony import */ var _utils_hook__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97033);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: ",
        "px;\n  height: ",
        "px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: ",
        "px;\n  height: ",
        "px;\n  border-radius: ",
        "px;\n  overflow: hidden;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    position: absolute;\n    top: -",
        "px;\n    left: -",
        "px;\n    width: ",
        "px;\n    height: ",
        "px;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var AVATAR_SIZE_METRICS = [
    {
        size: 16,
        radius: 5
    },
    {
        size: 24,
        radius: 8
    },
    {
        size: 32,
        radius: 12
    },
    {
        size: 44,
        radius: 16
    },
    {
        size: 50,
        radius: 10
    },
    {
        size: 64,
        radius: 24
    },
    {
        size: 100,
        radius: 36
    },
    {
        size: 116,
        radius: 15
    },
    {
        size: 189,
        radius: 20
    }, 
];
var AvatarSize;
(function(AvatarSize) {
    AvatarSize[AvatarSize["xsmall"] = 0] = "xsmall";
    AvatarSize[AvatarSize["small"] = 1] = "small";
    AvatarSize[AvatarSize["medium"] = 2] = "medium";
    AvatarSize[AvatarSize["large"] = 3] = "large";
    AvatarSize[AvatarSize["largeSquare"] = 4] = "largeSquare";
    AvatarSize[AvatarSize["xlarge"] = 5] = "xlarge";
    AvatarSize[AvatarSize["xxlarge"] = 6] = "xxlarge";
    AvatarSize[AvatarSize["xxxlarge"] = 7] = "xxxlarge";
    AvatarSize[AvatarSize["xxxxlarge"] = 8] = "xxxxlarge";
})(AvatarSize || (AvatarSize = {}));
var avatarWrapCSS = function(param) {
    var size = param.size;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject(), size, size);
};
var avatarCSS = function(param) {
    var size = param.size, radius = param.radius;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject1(), size, size, radius);
};
var avatarDecorationCSS = function(param) {
    var size = param.size;
    var ratio = size > 32 ? 2 : 1.75;
    var width = size * ratio;
    var axis = (width - size) / 2;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject2(), axis, axis, width, width);
};
var Avatar = function(param) {
    var className = param.className, id = param.id, _size = param.size, size = _size === void 0 ? 2 : _size, picture = param.picture, overrideDecoration = param.decoration, _hideDecoration = param.hideDecoration, hideDecoration = _hideDecoration === void 0 ? false : _hideDecoration, onClick = param.onClick;
    var avatarMetrics = AVATAR_SIZE_METRICS[size];
    var ref = (0,_utils_hook__WEBPACK_IMPORTED_MODULE_4__/* .useUserMarketItemInventory */ .wg)(id), data = ref.data, getDecoration = ref.getDecoration;
    var decoration = !hideDecoration ? overrideDecoration !== null && overrideDecoration !== void 0 ? overrideDecoration : getDecoration(data, _constants__WEBPACK_IMPORTED_MODULE_3__/* .MarketItemType.userPicture */ .q9.userPicture) : undefined;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
        css: avatarWrapCSS(avatarMetrics),
        className: className,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                css: avatarCSS(avatarMetrics),
                children: picture && picture.key ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_common_EFinderImage__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP, {
                    image: picture,
                    h: _components_common_EFinderImage__WEBPACK_IMPORTED_MODULE_0__/* .EFinderImageSizes.chatbot */ .ny.chatbot,
                    radius: avatarMetrics.radius
                }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_common_SvgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    icon: _public_icons_profile_32_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
                    d: avatarMetrics.size
                })
            }),
            decoration && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                css: avatarDecorationCSS(avatarMetrics),
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_common_EFinderImage__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP, {
                    image: size >= 3 ? decoration.object.pageProfile : decoration.object.pageComment
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (Avatar);


/***/ }),

/***/ 63732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fw": function() { return /* binding */ useBadgePresets; }
/* harmony export */ });
/* unused harmony export BadgeList */
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11717);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71618);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9150);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        "px;\n  display: inline-block;\n  height: 18px;\n  line-height: 16px;\n  border-radius: ",
        "px;\n  font-weight: 500;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n        cursor: pointer;\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n                  border: 1px solid transparent;\n                  background-image: linear-gradient(\n                      ",
        ",\n                      ",
        "\n                    ),\n                    ",
        ";\n                  background-origin: border-box;\n                  background-clip: content-box, border-box;\n                "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n                  border: 1px solid ",
        ";\n                  background-color: ",
        ";\n                "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n            ",
        "\n\n            span {\n              padding: 0 ",
        "px;\n            }\n          "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n                  background-image: ",
        ";\n                "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n                  background-color: ",
        ";\n                "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n            ",
        "\n\n            span {\n              padding: 0 ",
        "px;\n            }\n          "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n      color: ",
        ";\n      ",
        "\n\n      ",
        "\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline-block;\n  font-size: 0;\n\n  * + * {\n    margin-left: ",
        "px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}




var badgeCSS = function(radius, fontSize) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject(), fontSize, radius);
};
var badgeColorCSS = function(color, backgroundColor) {
    var border = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, isGradient = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, isClickable = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    return function(theme) {
        return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject8(), color, isClickable && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject1()), border ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject4(), isGradient ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject2(), theme.var.white, theme.var.white, backgroundColor) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject3(), backgroundColor, theme.var.white), chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.xxhsmall */ .Ki.xxhsmall) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject7(), isGradient ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject5(), backgroundColor) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject6(), backgroundColor), chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.xxsmall */ .Ki.xxsmall));
    };
};
var Badge = function(param) {
    var className = param.className, text = param.text, color = param.color, border = param.border, backgroundColor = param.backgroundColor, onClick = param.onClick, _radius = param.radius, radius = _radius === void 0 ? chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Radius.xsmall */ .wU.xsmall : _radius, _fontSize = param.fontSize, fontSize = _fontSize === void 0 ? chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .FontSizes.xxsmall */ .TS.xxsmall : _fontSize;
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__.u)();
    var ref;
    var isGradient = (ref = backgroundColor === null || backgroundColor === void 0 ? void 0 : backgroundColor.includes("linear-gradient")) !== null && ref !== void 0 ? ref : false;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
        css: [
            badgeCSS(radius, fontSize),
            badgeColorCSS(color !== null && color !== void 0 ? color : theme.true.white, backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : theme.var.gray500, border, isGradient, !!onClick), 
        ],
        className: className,
        onClick: onClick,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
            children: text
        })
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (Badge);
/** List Component */ var badgeListCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject9(), chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.xxsmall */ .Ki.xxsmall);
var BadgeList = function(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx("div", {
        css: badgeListCSS,
        children: children
    });
};
var useBadgePresets = function() {
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__.u)();
    var presets = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return {
            // fill
            grayFill: {
                backgroundColor: theme.var.gray400,
                color: theme.true.white
            },
            mainFill: {
                backgroundColor: theme.colors.main500,
                color: theme.true.white
            },
            blueFill: {
                backgroundColor: theme.colors.blue500,
                color: theme.true.white
            },
            pinkFill: {
                backgroundColor: theme.colors.pink500,
                color: theme.true.white
            },
            redFill: {
                backgroundColor: theme.colors.red500,
                color: theme.true.white
            },
            purpleFill: {
                backgroundColor: theme.service.violet,
                color: theme.true.white
            },
            honorFill: {
                backgroundColor: "linear-gradient(to right, #17dce4, #4db4ee)",
                color: theme.true.white
            },
            new: {
                backgroundColor: theme.colors.red500,
                color: theme.true.white
            },
            // border
            pink: {
                backgroundColor: theme.colors.pink500,
                border: true,
                color: theme.colors.pink500
            },
            yellow: {
                backgroundColor: theme.colors.yellow500,
                border: true,
                color: theme.colors.yellow500
            },
            orange: {
                backgroundColor: theme.colors.yellow700,
                border: true,
                color: theme.colors.yellow700
            },
            red: {
                backgroundColor: theme.colors.red500,
                border: true,
                color: theme.colors.red500
            },
            blue: {
                backgroundColor: theme.colors.blue500,
                border: true,
                color: theme.colors.blue500
            },
            main: {
                backgroundColor: theme.colors.main500,
                border: true,
                color: theme.colors.main500
            },
            fan: {
                backgroundColor: theme.colors.blue300,
                border: true,
                color: theme.colors.blue300
            },
            famousFill: {
                backgroundColor: theme.colors.playGra,
                color: theme.true.white
            }
        };
    }, []);
    return presets;
};


/***/ }),

/***/ 26581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports encodeMention, getDisplayText, hasMentions */
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11717);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71618);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47311);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39953);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39854);
/* harmony import */ var _contexts_global__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30259);
/* harmony import */ var _utils_webview__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81946);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  cursor: pointer;\n  font-weight: 500;\n  background-color: ",
        ";\n  padding: 1px 4px;\n  border-radius: 4px;\n  display: inline;\n\n  &:active {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var mentionCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject(), theme.colors.main500, theme.colors.main50, theme.colors.main100);
};
// Mention format: @[type:id:name]
// type: u = user, s = story, c = character
var MENTION_REGEX = /@\[(u|s|c):(\d+):([^\]]+)\]/g;
var MD_LINK_REGEX = /\[(.+?)\]\((https?:\/\/[^\s)]+)\)/g;
var PLAIN_URL_REGEX = /(https?:\/\/[^\s<]+)/g;
var parseContent = function(content) {
    var _loop = function() {
        var s = match.index;
        var e = s + match[0].length;
        var overlaps = tokens.some(function(t) {
            return s < t.end && e > t.start;
        });
        if (!overlaps) {
            tokens.push({
                kind: "link",
                start: s,
                end: e,
                url: match[2],
                label: match[1]
            });
        }
    }, _loop1 = function() {
        var s = match.index;
        var e = s + match[0].length;
        var overlaps = tokens.some(function(t) {
            return s < t.end && e > t.start;
        });
        if (!overlaps) {
            tokens.push({
                kind: "link",
                start: s,
                end: e,
                url: match[0],
                label: match[0]
            });
        }
    };
    var tokens = [];
    // Parse mentions
    MENTION_REGEX.lastIndex = 0;
    var match;
    while((match = MENTION_REGEX.exec(content)) !== null){
        tokens.push({
            kind: "mention",
            start: match.index,
            end: match.index + match[0].length,
            mentionType: match[1],
            mentionId: parseInt(match[2], 10),
            mentionName: match[3]
        });
    }
    // Parse markdown links [text](url)
    MD_LINK_REGEX.lastIndex = 0;
    while((match = MD_LINK_REGEX.exec(content)) !== null)_loop();
    // Parse plain URLs
    PLAIN_URL_REGEX.lastIndex = 0;
    while((match = PLAIN_URL_REGEX.exec(content)) !== null)_loop1();
    tokens.sort(function(a, b) {
        return a.start - b.start;
    });
    return tokens;
};
var MentionText = function(param) {
    var content = param.content, className = param.className;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.u)();
    var platform = (0,_contexts_global__WEBPACK_IMPORTED_MODULE_3__/* .useGlobalContext */ .bN)().platform;
    var web = (0,_utils_webview__WEBPACK_IMPORTED_MODULE_4__/* .useWebView */ .B9)().web;
    var navigate = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(path) {
        if (platform === _constants__WEBPACK_IMPORTED_MODULE_2__/* .Platform.web */ .t4.web) {
            router.push(path);
        } else {
            web.openPage(path);
        }
    }, [
        platform,
        router,
        web
    ]);
    var handleMentionClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(e, mention) {
        e.stopPropagation();
        e.preventDefault();
        switch(mention.type){
            case "u":
                navigate("/users/".concat(mention.id));
                break;
            case "s":
                navigate("/stories/".concat(mention.id));
                break;
            case "c":
                navigate("/play/characters/".concat(mention.id));
                break;
        }
    }, [
        navigate
    ]);
    var renderedContent = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var tokens = parseContent(content);
        if (tokens.length === 0) {
            return content;
        }
        var parts = [];
        var lastIndex = 0;
        tokens.forEach(function(token, idx) {
            if (token.start > lastIndex) {
                parts.push(/*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: content.slice(lastIndex, token.start)
                }, "text-".concat(idx)));
            }
            if (token.kind === "mention") {
                parts.push(/*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("span", {
                    css: mentionCSS(theme),
                    onClick: function(e) {
                        return handleMentionClick(e, {
                            type: token.mentionType,
                            id: token.mentionId,
                            name: token.mentionName,
                            fullMatch: "",
                            index: token.start
                        });
                    },
                    children: [
                        "@",
                        token.mentionName
                    ]
                }, "mention-".concat(idx)));
            } else if (token.kind === "link") {
                parts.push(/*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("a", {
                    href: token.url,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    onClick: function(e) {
                        return e.stopPropagation();
                    },
                    children: token.label
                }, "link-".concat(idx)));
            }
            lastIndex = token.end;
        });
        if (lastIndex < content.length) {
            parts.push(/*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: content.slice(lastIndex)
            }, "text-end"));
        }
        return parts;
    }, [
        content,
        theme,
        handleMentionClick
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
        className: className,
        children: renderedContent
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (MentionText);
// Utility function to encode a mention
var encodeMention = function(type, id, name) {
    var typeCode = type === "user" ? "u" : type === "story" ? "s" : "c";
    return "@[".concat(typeCode, ":").concat(id, ":").concat(name, "]");
};
// Utility function to get display text from encoded content
var getDisplayText = function(content) {
    return content.replace(MENTION_REGEX, "@$3");
};
// Check if content has any mentions
var hasMentions = function(content) {
    MENTION_REGEX.lastIndex = 0;
    return MENTION_REGEX.test(content);
};


/***/ }),

/***/ 87682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11717);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9150);
/* harmony import */ var chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82740);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39854);
/* harmony import */ var _utils_hook__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97033);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    color: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n\n  margin-right: ",
        "px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var nicknameCSS = function(color) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__.css)(_templateObject1(), color && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__.css)(_templateObject(), color), chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.xxxsmall */ .Ki.xxxsmall);
};
var Nickname = function(param) {
    var id = param.id, nickname = param.nickname, hasHonorPartnership = param.hasHonorPartnership, _size = param.size, size = _size === void 0 ? chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Sizes.xsmall */ .u8.xsmall : _size;
    var ref = (0,_utils_hook__WEBPACK_IMPORTED_MODULE_3__/* .useUserMarketItemInventory */ .wg)(id), data = ref.data, getDecoration = ref.getDecoration;
    var nicknameDeco = getDecoration(data, _constants__WEBPACK_IMPORTED_MODULE_2__/* .MarketItemType.userNickname */ .q9.userNickname);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
                css: nicknameCSS(nicknameDeco === null || nicknameDeco === void 0 ? void 0 : nicknameDeco.object.textColor),
                children: nickname
            }),
            hasHonorPartnership && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO, {
                icon: chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_1__/* .Honor */ .Sk,
                size: size
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Nickname);


/***/ })

}]);